/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import TextSection from '../../components/TextSection';
import ActionSection from '../../components/ActionSection';
import NevoBanner from '../../components/NevoBanner';
import ImageSection from '../../components/ImageSection';

import styles from './styles.module.scss'
import ChargingSolutionsBackground from '../../public/assets/images/charging-solutions-header.jpg';
import ChargingSolutionsImage from '../../public/assets/images/charging-solutions-background.jpg'
import WorkplaceImage from '../../public/assets/images/workplace-charging.jpg';
import DestinationImage from '../../public/assets/images/destination-charging.jpg';
import ApartmentImage from '../../public/assets/images/apartment-charging.jpg';
import NevoMontaLogo from '../../public/assets/images/nevo-monta.png';
import MontaImage from '../../public/assets/images/monta-image.jpg';


export default function ChargingSolutionsPage()  {
  return (
    <>
      <Head>
        <title>Charging Solutions | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={ChargingSolutionsBackground.src} className={styles.homeChargingHeader}>
        <h1 className='page-header-h1'>Charging Solutions.</h1>
      </PageHeader>

      <div className={`${styles.homeChargingPage} page-holder`}>
        <TextSection 
          header="At Nevo Advisory we can help you with your EV charging requirements, with a range of our trusted charge point suppliers and operators for all sizes of commercial sites in Ireland."
          text={<>
            With the growth of electric vehicle ownership across both personal and business fleets, more and more people are looking for electric vehicle charging. This may be at their place of work, at an overnight stay or even when they are out at various destinations such as shopping, cinema and many others.
            <br/><br/>
            We can recommend the best hardware, software and cloud services to help deliver a world-class service to your customers or employees.
            <br/><br/>
            Whether you require 1 to 5 charges outside your office for employees or you would like to create a charging hub with 10+ units for customers, Nevo Advisory can assist by providing guidance on the best solution to match your requirements.
          </>}
        />

        <div className={`${styles.chargingImage} image-section section`} style={{ backgroundImage: `url(${ChargingSolutionsImage.src})` }}>&nbsp;</div>

        <div className={`${styles.chargingSection} cooler-padding`}>
          <ImageSection
            header='Workplace Charging'
            text='More and more employees would like to charge at work. We can help design the best solution.'
            image={WorkplaceImage.src}
          />

          <ImageSection
            header='Destination Charging'
            text='Offering charging for your customers or members is a great USP and helps you stand out from the competition.'
            image={DestinationImage.src}
          />

          <ImageSection
            header='Apartment Charging'
            text='Tenants are asking about charging their EVs, we have the knowledge and expertise to help manage their expectations while also maximizing the return on investment.'
            image={ApartmentImage.src}
          />
        </div>

        <div className={`${styles.montaPartnerShip} padding`}>
          <img className={styles.nevoMontaLogo} src={NevoMontaLogo.src} alt='Nevo Monta Partnership'/>
          <h1 className={`${styles.montaHeader} perfect-header`}>Nevo is the leading partner for Monta</h1>
        </div>

        <div className={`${styles.montaDetails} cooler-padding`}>
          <ImageSection
            header='Who is Monta?'
            text={<>
              Monta is the operating platform powering the EV ecosystem serving drivers, companies, cities, and the electricity grid with one integrated software solution.<br/><br/>Monta believes that accelerating and democratising the adoption of EV technology is key to building a better future. Monta’s mission is to provide the best technology solutions for the entire EV charging cycle. At our core, we provide access, innovation and reliability to the mobility transformation.<br/><br/>Monta is here to make the transition to electric mobility as seamless and exciting as possible. With a single integrated software built to EV better.
            </>}
            image={MontaImage.src}
            switchDirection
          />
        </div>

        <ActionSection 
          header="Arrange an initial call"
          text="Discover the perfect charging solution tailored to your needs. Contact us today to learn more about how we can help you make the switch to electric."
          buttonText="Contact Us"
          href="/contact-us"
        />

        <NevoBanner />
      </div>

      <Footer />
    </>
  )
};
